// extracted by mini-css-extract-plugin
export default {"homewrapper":"alumniheader_homewrapper__48rR1","projects":"alumniheader_projects__qZ1hp","alumni":"alumniheader_alumni__NbkM1","header-overlay":"alumniheader_header-overlay__fQ+pp"};